








































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import hexabaseState from '@/store/hexabase';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue'
import MasterSelectMultiSetControl from '@/components/common/modules/MasterSelectMultiSetControl.vue';
import MultipleLineText from '@/components/common/elements/MultipleLineText.vue'
import Button from '@/components/common/elements/Button.vue';
import DialogData from '@/components/common/modules/DialogData.vue';
import ActionButtonWithTablePanel from '@/components/common/modules/ActionButtonWithTablePanel.vue'
import FileManager from '@/components/common/modules/FileManager.vue';

import Estimate from '@/models/estimateModel';
import * as MatterList from '@/constants/matter/materialList';
import { FileFormResponse } from '@/constants/form/types';

@Component({
  components: {
    InputNoVModel,
    SelectNoVModel,
    MasterSelectMultiSetControl,
    MultipleLineText,
    Button,
    DialogData,
    ActionButtonWithTablePanel,
    FileManager
  },
})
/* eslint-disable @typescript-eslint/camelcase */
export default class MaterialListTab extends Vue {
  private estimate = new Estimate();
  inheritAttrs = false;
  
  @Prop({ default: () => ({}) })
  private item: any;
  // DialogData
  private dialogHeaderDetailData = false;
  private dialogHeaderDetailDataTitle = MatterList.DialogHeaderDetailDataTitle;
  private dialogHeaderDetailColmuns = MatterList.DialogHeaderDetailColmuns;
  private dialogHeaderDetailBody: any = [];
  // FileManager
  private showDialog = false;
  private estimateBasicFileDialogTitle = MatterList.EstimateBasicFileDialogTitle;
  private estimateBasicFileDialogColumnItems = MatterList.EstimateBasicFileDialogColumnItems;
  private projectId = hexabaseState.applicationId;
  private estimateFileItemId = '';
  private isLoading = false;

  @Emit('tabChildrenEventRelay')
  private emit(response: any) {
    return response;
  }

  private async clickButtonRelay(event: any) {
    switch (event.buttonName) {
      case 'detail': {
        this.emit({ action: 'clickRowOpratipon', data: event.record });
        break;
      }
      case 'show': {
        try {
          this.setLoading(true);
          this.isLoading = true;

          // Clear
          this.dialogHeaderDetailBody.splice(0);

          const estimate = await this.estimate.getLinked(
            this.projectId,
            this.item.estimateDsId,
            event.record.i_id,
            hexabaseState.datastoreIds['見積書発行履歴']
          );
          if (estimate.result['t_estimate_issuance_history'] !== undefined) {
            const estimateIssuanceHistory = estimate.result['t_estimate_issuance_history'];
            const issuerFieldId = Object.keys(estimateIssuanceHistory.fields).find((key: any) => estimateIssuanceHistory.fields[key].display_id === 'issuer');
            const issueDatetimeFieldId = Object.keys(estimateIssuanceHistory.fields).find((key: any) => estimateIssuanceHistory.fields[key].display_id === 'issue_datetime');
            estimateIssuanceHistory.items.forEach((item: any) => {
              this.dialogHeaderDetailBody.push({
                issuer: item[issuerFieldId!],
                issue_datetime: this.estimate.editDatetype(item[issueDatetimeFieldId!], 'Asia/Tokyo', 'yyyy/MM/dd H:mm')
              })
            });
          }

          this.isLoading = false;
          this.dialogHeaderDetailData = true;
        } finally {
          this.setLoading(false);
        }
        break;
      }
      case 'fileAttach': {
        this.estimateFileItemId = event.record.i_id;
        this.showDialog = true;
        break;
      }
    }
  }

  private buttonActionRelay(event: any) {
    this.emit({ action: 'buttonAction', event });
  }

  private closeDialogHeaderDetailData () {
    this.dialogHeaderDetailData = false;
  }

  private closeFileManager() {
    this.showDialog = false;
  }

  private setLoading(bool: boolean) {
    this.$store.commit('hexabase/setIsLoading', bool);
  }

  private emitFileData(event: FileFormResponse) {
    this.emit({ action: 'catchFileForm', event });
  }
}
